import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

const CompareScoreChip = ({ score, scoreReference, isCorner }) => {
    const isDifferencePositive = score > scoreReference;
    let scoreDifference = 0;
    if (isDifferencePositive) {
        scoreDifference = Math.round(((score - scoreReference) / scoreReference) * 100);
    } else {
        scoreDifference = Math.round(((scoreReference - score) / scoreReference) * 100);
    }

    if (scoreReference < 0.001 || !scoreDifference || isNaN(scoreDifference)) {
        return null;
    }
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '2px',
                justifyContent: 'center',
                verticalAlign: 'middle',
                backgroundColor: () =>
                    isDifferencePositive ? 'error.main' : 'success.main',
                color: () => (isDifferencePositive ? 'white.light' : 'dark.main'),
                borderRadius: () => (isCorner ? '0 0 0 4px' : 8),
                py: '2px',
                px: () => (isCorner ? '4px' : 1),
                maxWidth: '80px',
                fontSize: '0.75rem',
            }}
        >
            {isDifferencePositive ? (
                <ArrowUpwardIcon fontSize="12px" />
            ) : (
                <ArrowDownwardIcon fontSize="12px" />
            )}
            <span
                style={{
                    verticalAlign: 'middle',
                }}
            >
                {scoreDifference}%
            </span>
        </Box>
    );
};

CompareScoreChip.propTypes = {
    score: PropTypes.number,
    scoreReference: PropTypes.number,
    isCorner: PropTypes.bool,
};

export default CompareScoreChip;
